import React from 'react';
import PropTypes from 'prop-types';
import Header2026 from '../Header2026/Header2026';

const HeaderNoData = ({ menu, landingPageCartId = null }) => {
  if (menu !== null) {
    return (
      <Header2026
        data={menu}
        characterLimit={60}
        landingPageCartId={landingPageCartId}
      />
    );
  }
  return null;
};

HeaderNoData.propTypes = {
  menu: PropTypes.objectOf(PropTypes.shape).isRequired,
  landingPageCartId: PropTypes.string
};

export default HeaderNoData;
